import React from 'react';
import { useAuth } from '../context/AuthContext';
import styles from '../styles/UserProfile.module.css';

const UserProfile = () => {
  const { user } = useAuth();

  return (
    <div className={styles.container}>
      <div className={styles.profileCard}>
        <h1 className={styles.title}>Profile Dashboard Coming Soon!</h1>
        <div className={styles.content}>
          <p className={styles.greeting}>Welcome, {user?.username}!</p>
          <div className={styles.featuresList}>
            <h2>Your Personal League Hub is Under Construction</h2>
            <p className={styles.description}>
              We're working hard to bring you a comprehensive profile dashboard that will include:
            </p>
            <ul>
              <li>Season Lock Summary & Statistics</li>
              <li>Personal Lock Performance Metrics</li>
              <li>Historical Pick Analysis</li>
              <li>League Standing Tracker</li>
              <li>Achievement Badges</li>
              <li>Custom Profile Settings</li>
            </ul>
            <p className={styles.comingSoon}>
              Stay tuned for these exciting features! We're making sure your profile experience
              will be worth the wait.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;